import {
    devicesConstants,
    devicesFulfilledConstants,
    devicesPendingConstants,
    devicesRejectedConstants
} from '../actions';

const initialState = {
    items: [],
    total: 0,
    loading: true,
    error: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case devicesConstants.DEVICES_CLEARED:
            return initialState;
        case devicesPendingConstants.DEVICES_LOADED:
            return {
                ...state,
                loading: true
            };
        case devicesPendingConstants.DEVICE_GROUP_UPDATED:
            return {
                ...state,
                loading: true
            };
        case devicesFulfilledConstants.DEVICES_LOADED:
            return {
                items: action.payload.devices,
                total: action.payload.total,
                loading: false
            };
        case devicesFulfilledConstants.DEVICE_UPDATED:
        case devicesFulfilledConstants.DEVICE_CREATED:
            return {
                ...state,
                loading: false,
                items: state.items.map(item => (item.id === action.payload.id ? action.payload : item))

            };
        case devicesFulfilledConstants.DEVICE_DELETED:
            return state;
        case devicesFulfilledConstants.DEVICE_UNASSIGNED:
            return {
                ...state,
                items: state.items.map(item => action.payload.find(el => el.id === item.id) || item),
                loading: false,
            };
        case devicesFulfilledConstants.DEVICE_GROUP_UPDATED:
        case devicesFulfilledConstants.DEVICES_GROUPED_UNASSIGNED:
            return {
                ...state,
                items: state.items.map(item => {
                    const newItems = action.payload;
                    for (let i = 0; i < newItems.length; i++) {
                        if (item.id === newItems[i].id) return newItems[i];
                    }
                    return item;
                }),
                loading: false,
            };
        case devicesFulfilledConstants.DEVICE_PROFILE_INFO_LOADED:
            const { data, deviceId } = action.payload;
            return {
                ...state,
                items: state.items.map(item => (item.id === deviceId ? { ...item, profileData: data, isLoading: false, error: '' } : item)),
            };
        case devicesFulfilledConstants.DEVICE_ASSIGNED:
            return {
                ...state,
                items: state.items.map(item => action.payload.find(el => el.id === item.id) || item),
                loading: false,
            };

        case devicesFulfilledConstants.RESERVE_CREATED:
            return {
                ...state,
                loading: false,
            };

        case devicesFulfilledConstants.RESERVE_UPDATED:
            return {
                ...state,
                loading: false,
            };

        case devicesFulfilledConstants.RESERVE_DELETED:
            return {
                ...state,
                loading: false,
            };

        case devicesPendingConstants.DEVICE_PROFILE_INFO_LOADED:
            return {
                ...state,
                items: state.items.map(item => (item.id === action.meta ? { ...item, profileData: { isLoading: true, error: '' } } : item)),
            };

        case devicesPendingConstants.RESERVE_DELETED:
        case devicesPendingConstants.RESERVE_UPDATED:
        case devicesPendingConstants.RESERVE_CREATED:
        case devicesPendingConstants.DEVICE_UPDATED:
        case devicesPendingConstants.DEVICE_ASSIGNED:
        case devicesPendingConstants.DEVICE_CREATED:
        case devicesPendingConstants.DEVICE_UNASSIGNED:
        case devicesPendingConstants.DEVICES_GROUPED_UNASSIGNED:
            return {
                ...state,
                loading: true,
            };
        case devicesRejectedConstants.DEVICE_PROFILE_INFO_LOADED:
            const error = action.payload;

            return {
                ...state,
                items: state.items.map(item =>
                    (item.id === action.meta
                        ? { ...item, profileData: { isLoading: false, error: error.message } }
                        : item
                    )),
            };
        case devicesRejectedConstants.RESERVE_DELETED:
        case devicesRejectedConstants.RESERVE_UPDATED:
        case devicesRejectedConstants.RESERVE_CREATED:
        case devicesRejectedConstants.DEVICE_ASSIGNED:
        case devicesRejectedConstants.DEVICE_CREATED:
        case devicesRejectedConstants.DEVICE_UPDATED:
        case devicesRejectedConstants.DEVICE_DELETED:
        case devicesRejectedConstants.DEVICE_UNASSIGNED:
        case devicesRejectedConstants.DEVICES_GROUPED_UNASSIGNED:
        case devicesRejectedConstants.DEVICE_GROUP_UPDATED:
        case devicesRejectedConstants.DEVICES_LOADED: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }
        default:
            return state;
    }
}
